import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Image from './Image';

const URL = process.env.REACT_APP_BASE_FILES_URL;

export default function Avatar({ iconId, sx }) {
  return (
    <Box
      sx={{
        ...sx,
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: iconId ? 'none' : 'text.disabled',
      }}
    >
      {iconId && (
        <Image
          src={`${URL}/${iconId}`}
          alt="avatar"
          style={{ display: 'block', height: '40px', width: '40px', borderRadius: '50%', objectFit: 'cover' }}
        />
      )}
    </Box>
  );
}

Avatar.propTypes = {
  iconId: PropTypes.string,
  sx: PropTypes.object,
};

Avatar.defaultProps = {
  iconId: '',
  sx: {},
};
